import React, { useEffect, useState, useMemo, useContext } from 'react';
import {
	Question,
	QuestionChoice,
} from '../../../../../../hoc/context/product/context-model';
import Button from '../../../../../../hoc/components/button';
import Feedback from '../../feedback';
import context from '../../../../../../hoc/context/product/context';
import { Choice } from './choice/choice';
import AnalyticsFactory from '../../../../../../../services/analytics-factory';
import { enrollmentContext } from '../../../../../../hoc/context/enrollment/enrollment-context';
import { ChoiceType } from '../../../../../../../services/analytics';
import Section from '../../../../../../hoc/components/section/section';

export interface DefaultQuestionProps {
	question: Question;
	answer: string | undefined;
	answerQuestion: Function;
}

export const DefaultQuestion = ({
	question,
	answer,
	answerQuestion,
}: DefaultQuestionProps) => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const [selectedAnswer, setSelectedAnswer] = useState<string | undefined>(
		undefined
	);
	const [feedback, setFeedback] = useState<string>('');
	const [canContinue, setCanContinue] = useState<boolean>(true);
	const [disable, setDisable] = useState<boolean>(true);
	const sendAnalytics = (
		selectedAnswerToTrack: ChoiceType,
		answerSelected: string | undefined,
		eventLabel: string
	) => {
		//TODO: this provider ga or any other provider can be added in config instead of hardcoding
		const analytics = AnalyticsFactory.createAnalytics('ga');
		analytics.sendQuestionEvent(
			question,
			selectedAnswerToTrack,
			eventLabel,
			answerSelected,
			ctxt,
			enrollmentCtxt
		);
	};
	const continueButtonPressed = () => {
		let selectedAnswerToTrack = selectedAnswer;
		if (selectedAnswer === undefined) {
			selectedAnswerToTrack = question.label ? question.label : question.id;
		}
		sendAnalytics(selectedAnswerToTrack, selectedAnswer, buttonLabel());
		answerQuestion(selectedAnswer);
	};
	useEffect(() => {
		setCanContinue(true);
		setSelectedAnswer(answer);
		setFeedback('');
	}, [question, answer]);

	useEffect(() => {
		if (answer !== undefined || !question.choices?.length) {
			setDisable(false);
		} else if (selectedAnswer === undefined) {
			setDisable(true);
		}
	}, [selectedAnswer, question, answer]);

	const showChoices = useMemo(() => {
		return question.choices?.length ? true : false;
	}, [question.choices]);

	const buttonLabel = () => {
		return question?.buttonLabel
			? question.buttonLabel
			: ctxt.json.pages.questions.next_button_label;
	};

	return (
		<Section
			title={question.title}
			description={question.description}
			width="max-w-4xl">
			{showChoices && (
				<div className="flex flex-col gap-5 lg:gap-9 min-w-[320px] max-w-xl self-center">
					{question.choices?.map(
						(choiceItem: QuestionChoice, index: number) => (
							<Choice
								key={index}
								choice={choiceItem}
								currentAnswer={selectedAnswer}
								onClick={(choice: QuestionChoice) => {
									setSelectedAnswer(choice.value as string);
									setFeedback(choice.feedback as string);
									setCanContinue(choice.continue !== false);
									sendAnalytics(
										choice?.value,
										choice?.value,
										choice.label ? choice.label : ''
									);
									setDisable(false);
								}}
							/>
						)
					)}
				</div>
			)}
			{feedback && <Feedback feedback={feedback} />}
			{canContinue && (
				<div className="flex flex-col justify-center">
					<Button disabled={disable} onClick={continueButtonPressed}>
						{buttonLabel()}
					</Button>
				</div>
			)}
		</Section>
	);
};
